import { render, staticRenderFns } from "./PalletScans.vue?vue&type=template&id=9d23bad4&scoped=true"
import script from "./PalletScans.vue?vue&type=script&lang=js"
export * from "./PalletScans.vue?vue&type=script&lang=js"
import style0 from "./PalletScans.vue?vue&type=style&index=0&id=9d23bad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d23bad4",
  null
  
)

export default component.exports